import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import InspectionForm from "../Components/InspectionForm";
import { saveInspection } from "../Reducers/actions";

const InspectionInsertPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = (values) => {
    // Extract IDs from objects if needed
    const submitData = {
      ...values,
      company_id: typeof values.company_id === 'object' && values.company_id !== null
        ? values.company_id._id
        : values.company_id,
      template_id: typeof values.template_id === 'object' && values.template_id !== null
        ? values.template_id._id
        : values.template_id,
      inspector_id: typeof values.inspector_id === 'object' && values.inspector_id !== null
        ? values.inspector_id._id
        : values.inspector_id,
    };

    dispatch(saveInspection(submitData)).then((result) => {
      if (result.success) {
        alert("Inspectie succesvol aangemaakt!");
        navigate("/zwembadinspecties/inspecties");
      } else {
        alert("Er is een fout opgetreden bij het aanmaken van de inspectie.");
      }
    });
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h3>Nieuwe Inspectie Aanmaken</h3>
            </div>
            <div className="card-body">
              <InspectionForm onSubmit={handleSubmit} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InspectionInsertPage;
